import React from 'react';
import clsx from 'clsx';
import styles from './Card.module.scss';

const Card = ({
  children,
  disabled = false,
  onClick,
}) => {
  const handleClick = disabled ? undefined : onClick;

  const className = clsx(styles.Card, {
    [styles['Card--disabled']]: disabled,
    [styles['Card--clickable']]: !!handleClick,
  });

  return (
    <div className={className} onClick={handleClick}>
      {children}
    </div>
  );
};

export default Card;
